import { Map } from 'immutable';
import {
  LIST_RATE_LIMIT_POLICIES,
  CREATE_RATE_LIMIT_POLICY,
  UPDATE_RATE_LIMIT_POLICY,
  DELETE_RATE_LIMIT_POLICY,
  LIST_TENANT_RATE_LIMITS,
  GET_TENANT_RATE_LIMIT,
  SET_TENANT_TIER,
  SET_TENANT_OVERRIDE,
  REMOVE_TENANT_OVERRIDE,
} from '../lib/constant';

const initialState = Map({
  listPoliciesResponse: {},
  createPolicyResponse: {},
  updatePolicyResponse: {},
  deletePolicyResponse: {},
  listTenantsResponse: {},
  getTenantResponse: {},
  setTenantTierResponse: {},
  setOverrideResponse: {},
  removeOverrideResponse: {},
});

export default function (state = initialState, action) {
  switch (action.type) {
    case LIST_RATE_LIMIT_POLICIES:
      return { ...state, listPoliciesResponse: action.payload };
    case CREATE_RATE_LIMIT_POLICY:
      return { ...state, createPolicyResponse: action.payload };
    case UPDATE_RATE_LIMIT_POLICY:
      return { ...state, updatePolicyResponse: action.payload };
    case DELETE_RATE_LIMIT_POLICY:
      return { ...state, deletePolicyResponse: action.payload };
    case LIST_TENANT_RATE_LIMITS:
      return { ...state, listTenantsResponse: action.payload };
    case GET_TENANT_RATE_LIMIT:
      return { ...state, getTenantResponse: action.payload };
    case SET_TENANT_TIER:
      return { ...state, setTenantTierResponse: action.payload };
    case SET_TENANT_OVERRIDE:
      return { ...state, setOverrideResponse: action.payload };
    case REMOVE_TENANT_OVERRIDE:
      return { ...state, removeOverrideResponse: action.payload };
    default:
      return state;
  }
}
